import store from '@/store';
import { ComputedRef, computed, ComputedSetter } from 'vue';

export interface StoreAction {
	fullPath: string;
}
export interface StoreGetter {
	fullPath: string;
}

export type MapComputedResult = Record<string, ComputedRef>;
export const mapComputed = (getterObj: Record<string, StoreGetter>): MapComputedResult => {
	const objs = Object.entries(getterObj);
	const mappedGettersObj: [string, ComputedRef][] = objs.map(([k, v]) => [k, mapComputedGetter(v)]);
	return Object.fromEntries(mappedGettersObj);
};

export const mapActions = (actionsObj: Record<string, StoreAction>) => {
	const objs = Object.entries(actionsObj);
	const mappedActionsObj = objs.map<[string, (payload?: unknown) => ReturnType<ReturnType<typeof mapAction>>]>(([k, v]) => [
		k,
		(payload) => mapAction(v)(payload),
	]);
	return Object.fromEntries(mappedActionsObj);
};

export const mapGetter = <T>(getter: StoreGetter): T => store.getters[getter.fullPath];
export const mapAction =
	<T>(action: StoreAction): ((payload?: unknown) => Promise<T>) =>
	(payload?: unknown) =>
		store.dispatch(action.fullPath, payload, { root: true });

export const mapComputedGetter = (getter: StoreGetter): ComputedRef => computed(() => mapGetter(getter));

export const useWritableComputed = <T>(getter: StoreGetter, setter: ComputedSetter<T>) =>
	computed<T>({
		set: setter,
		get: () => mapGetter<T>(getter),
	});
/* Deprecated_JS */

import { mapGetters, mapActions as mapActionsOld } from 'vuex';

// @ts-ignore
const buildMapper = (wrapper) => (objs) => wrapper(Object.fromEntries(Object.entries(objs).map(([k, v]) => [k, v.fullPath])));

export const mapGettersShorthand = buildMapper(mapGetters);
export const mapActionsShorthand = buildMapper(mapActionsOld);
